import React from "react";
import {
  TopToolbar,
  EditButton,
  Button,
  Tab,
  TabbedShowLayout,
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceManyField,
  Pagination,
  Datagrid
} from "react-admin";
import { Link } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Add";

const SchoolShowActions = ({ basePath, data, resource }) => {
  return (
    <TopToolbar>
      <EditButton basePath={basePath} record={data} />
      {data && (
        <Button
          label="Add Team"
          component={Link}
          to={{
            pathname: "/teams/create",
            state: { record: { school_id: data.id } }
          }}
        >
          <CreateIcon />
        </Button>
      )}
    </TopToolbar>
  );
};

const SchoolShow = (props) => {
  return (
    <Show actions={<SchoolShowActions />} {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
          <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Name" source="name" />
            <TextField label="Slug" source="slug" />
            <TextField label="Abbreviation" source="abbr" />
            <TextField label="Logo URL" source="logoUrl" />
            <TextField label="Stable ID" source="stableId" />
          </SimpleShowLayout>
        </Tab>
        <Tab label="teams">
          <SimpleShowLayout>
            <ReferenceManyField
              reference="teams"
              target="school_id"
              addLabel={false}
              pagination={<Pagination />}
              fullWidth
            >
              <Datagrid rowClick="show">
                <TextField source="id" />
                <TextField source="sportCode" />
                <TextField source="name" />
                <TextField source="teamCode" />
              </Datagrid>
            </ReferenceManyField>
          </SimpleShowLayout>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default SchoolShow;
